import { useContext } from 'react'

import { DataContext } from '../context/DataContext'
import { upsertAbandonedCart } from '../helpers/pinflagRequest'

export const useAbandonedCart = () => {
  const { cartData } = useContext(DataContext)

  return {
    upsertAbandonedCart: (customerData) => upsertAbandonedCart(cartData, customerData)
  }
}
